export default __webpack_public_path__ + "static/media/linkedin_alt.82e2766c.svg";